export default {
  'menu.exception.403': '403',
  'exception.result.403.description':
    'Access to this resource on the server is denied.',
  'exception.result.403.back': 'Back',
};
